module.exports = __webpack_public_path__ + "assets/images/eurosport_1.2bbcb94fbfbc02a4b38f842916976636.png";